<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t("messaggistica")}}</h1></div>
            <div class="content content-full">
                <div class="title">{{$t("messaggistica_conversazioni_attive")}}</div>
                <div class="container">
                    <div class="row-sezione">
                        <div v-if="this.conversations.length">
                            <div class="blocchetto p-0" v-for="conversation in this.conversations">
                              <div class="d-flex justify-content-between">
                                <div v-if="conversation.type === 'ORDINE'" class="p-2">
                                    {{$t('carrello_ordine_label').capitalize()}} n°: {{conversation.item.id}}
                                    -
                                    <inc-order-status :status="conversation.item.status"/>
                                    <br>
                                    <b>
                                        <inc-order-datetime
                                                :datetime-delivery-takeaway="conversation.item.data_ora_consegna_ritiro"
                                                :delivery-takeaway-end-slot="conversation.item.consegna_ritiro_fine_fascia"
                                                :language="language"/>
                                    </b>
                                    <br>
                                    {{$t('ordini_pagamento')}} :
                                    <inc-order-payment-mode
                                        :payment-mode="conversation.item.modalita_pagamento"
                                        :payment-preference="conversation.item.preferenza_pagamento"
                                        :order-type="conversation.item.tipo_ordine"
                                    />
                                    <br>
                                    <span class="color">
                                        <b>{{$t('totale')}}:
                                            {{conversation.item.totale_ordine.toFixedGood(2)}} {{locale_currency}}
                                        </b>
                                    </span>
                                </div>
                                <div v-else-if="conversation.type === 'PRENOTAZIONE'" class="p-2">
                                    {{$t('prenotazione')}} n°:{{conversation.item.id}}
                                    <br>
                                    <b>
                                        {{conversation.item.n_persone}}
                                        {{$tc('prenotazioni_tavolo.persona', conversation.item.n_persone)}}
                                        -
                                        {{moment(conversation.item.data_ora_prenotazione).locale(language)
                                        .format('dddd DD MMMM YYYY')}}
                                        {{$t('ore_in_data')}}
                                        {{moment(conversation.item.data_ora_prenotazione).locale(language).format('HH:mm')}}
                                    </b><br>
                                    {{$t('prenotazione.status')}}:
                                    <inc-reservation-status :status="conversation.item.status"/>
                                </div>
                                <div class="d-flex flex-column align-items-stretch">
                                  <a href="#" @click.prevent="showMessagingModal(conversation)">
                                    <div class="d-flex align-items-center align-items-stretch bg-color-dark my-0 h-100" style="padding: 6px;">
                                      <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('messaggistica')">
                                              mark_as_unread
                                              </span>
                                      <span class="badge badge-info"
                                            v-if="getConversationMsgCounter(conversation)">
                                                  {{getConversationMsgCounter(conversation)}}
                                              </span>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                        </div>
                        <div v-else>
                            <p class="text-center f14" style="margin-top: 30px;">
                                {{$t("messaggistica_no_ordine_prenotazione")}}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="container d-none d-md-block">
                  <hr>
                    <div class="row-sezione d-flex justify-content-center">
                            <router-link :to="{name:'home'}">
                                <button type="button" class="btn btn-default">{{$t("btn_indietro")}}</button>
                            </router-link>
                    </div>
                </div>
            </div>
        </div>
        <modal-messaging v-if="this.show_modal" @close="show_modal = false"
                         :type="this.selected_conversation.type"
                         :item="this.selected_conversation.item"
        />
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import {getMessaging} from "../../api/account";

    import IncOrderStatus from "../orders/partials/IncOrderStatus";
    import IncOrderPaymentMode from "../orders/partials/IncOrderPaymentMode";
    import IncOrderDatetime from "../orders/partials/IncOrderDatetime";
    import IncReservationStatus from "../reservations/partials/IncReservationStatus";
    import ModalMessaging from "./partials/ModalMessaging";

    export default {
        name: "ActiveConversations",
        components: {ModalMessaging, IncReservationStatus, IncOrderDatetime, IncOrderPaymentMode, IncOrderStatus},
        data() {
            return {
                conversations: [],

                show_modal: false,
                selected_conversation: null
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id
            }),
            ...mapState('auth', {
                user: state => state
            }),
            ...mapState('chat', {
                unread_messages: state => state.unread_messages
            }),
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            }),
            ...mapGetters('chat', {
                getMsgCounterFromId: 'getMsgCounterFromId'
            })
        },
        methods: {
            fetch: function () {
                this.showLoading(true);
                getMessaging(this.language, {
                    id_ristorante: this.id_ristorante,
                    api_key: this.user.api_key,
                    f_active: true,
                    counter_messaggi: false
                }).then((response) => {
                    this.conversations = response.items;
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            showMessagingModal: function (conversation) {
                this.selected_conversation = conversation;
                this.show_modal = true;
            },
            getConversationMsgCounter: function (conversation) {
                try {
                    return this.getMsgCounterFromId(conversation.item.chat.id);
                } catch (e) {
                    return null
                }
            },
            ...mapActions('global', [
                'showLoading'
            ]),
        }
    }
</script>
